export default __webpack_public_path__ + "static/media/keyNew.7da5f9c4.svg";